/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { GET_AMENITIES, GET_AMENITIES_ERROR } from '../constants';

const INITIALSTATE = {
    amenity: { results: [] },
};

const amenity = (state = INITIALSTATE, action) => {
    const st = { ...state };
    switch (action.type) {
        case GET_AMENITIES:
            st.amenity = { results: action.payload, isValid: true };
            return st;
        case GET_AMENITIES_ERROR:
            st.amenity = { error: action.error, results: [], isValid: false };
            return st;
        default:
            return state;
    }
};

export default amenity;
